import { NgModule, type Type } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CURRENT_HOST_ID } from 'src/app/core/host-identification/current-host-id';
import { HostId } from 'src/app/core/host-identification/host-id.enum';

import { AppRoutePath } from './app-route-path.enum';
import { AppRoutePreloadingStrategy } from './app-route-preloading-strategy';

export const routes: Routes = [
  {
    path: AppRoutePath.Doorway,
    loadChildren: async () =>
      import('src/app/features/doorway/doorway.module').then(m => m.DoorwayModule as Type<unknown>)
  },
  {
    path: AppRoutePath.Motorization,
    loadChildren: async () =>
      import('src/app/features/motorization/motorization.module').then(m => m.MotorizationModule as Type<unknown>)
  },
  {
    path: AppRoutePath.VehicleLength,
    loadChildren: async () =>
      import('src/app/features/vehicle-length/vehicle-length.module').then(m => m.VehicleLengthModule as Type<unknown>)
  },
  {
    path: AppRoutePath.Preconfig,
    loadChildren: async () =>
      import('src/app/features/preconfig/preconfig.module').then(m => m.PreconfigModule as Type<unknown>)
  },
  {
    path: AppRoutePath.Configuration,
    loadChildren: async () =>
      import('src/app/features/configuration/configuration.module').then(m => m.ConfigurationModule as Type<unknown>)
  },
  {
    path: AppRoutePath.OnlineCode,
    loadChildren: async () =>
      import('src/app/features/online-code/online-code.module').then(m => m.OnlineCodeModule as Type<unknown>)
  }
];

if (CURRENT_HOST_ID === HostId.Local) {
  routes.unshift({
    path: '',
    redirectTo: AppRoutePath.Doorway,
    pathMatch: 'full'
  });
}

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: AppRoutePreloadingStrategy,
      urlUpdateStrategy: 'eager',
      paramsInheritanceStrategy: 'always',
      enableTracing: false, // enable to debug routing
      useHash: false,
      anchorScrolling: 'enabled',
      // removed the reload behaviour to allow anchor scrolling to the content area during the configuration.
      // MBCC-724 otherwise scroll to position is not possible because it is reset to top
      // onSameUrlNavigation: 'reload',

      // scrollPositionRestoration intentionally disabled since treated in router.effects.ts
      // also see documentation here: https://angular.io/api/router/ExtraOptions#scrollPositionRestoration
      scrollPositionRestoration: 'disabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
